<template>
	<span class="sector" v-if="sector">{{ sector }}</span>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		name: 'ColumnSector',
		props: {
			rowData: {
				type: Object,
				required: true,
			},
			rowIndex: {
				type: Number,
			},
		},
		computed: {
			sector() {
                return this.rowData.sector;
			},
		},
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>
